import { BasePortalConfig } from './base-portal-config';
import { PortalType } from './portal-type';

//Config specific to partner center portal
export class SeOpsPortalConfig extends BasePortalConfig {
  portalName = PortalType.SEOps;
  searchApplicable = false;
  actionCenterApplicable = false;
  directoryPickerApplicable = false;
  titleKey: string = 'shell.microsoftLogoText_seops';
  aboutSubTitleKey = 'settings.modalSubTitle_seops';
  signInPath = '/aad?action=signin&returnPath=/home&prompt=select_account';
  pushSurveyId = 'salesops_nps';
  pullSurveyId = 'salesops_feedback';
  surveyIntegrationId = 'seops';
  supportPanelIntegrationId = 'seops';
  useFeedbackPanel = true;
  useSupportExtFeatures = false;
  useFDSurveyEndpoint = false;
  homeUrl: string = '/home';

  /**
   *
   */
  constructor() {
    super();
    this.setApiEndpoints();
  }

  setApiEndpoints() {
    this.apiEndpoints = {
      auth: '{domain}/api/user/accesstokens?tokenResources=MicrosoftGraph&tokenResources=AccountsFirstPartyApp',
      preference: '{domain}/api/user/preference',
    };
  }
}
